import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, CalendarCheckIcon, GitCompareIcon } from 'lucide-react';
import { Vehicle } from '../../data/easylease';
interface FeaturedCarCardProps {
  vehicle: Vehicle;
  onAsk: (vehicle: Vehicle) => void;
  onCompare: (vehicle: Vehicle) => void;
  onCheckAvailability: (vehicle: Vehicle) => void;
}
export function FeaturedCarCard({
  vehicle,
  onAsk,
  onCompare,
  onCheckAvailability
}: FeaturedCarCardProps) {
  return <motion.article whileHover={{
    y: -4
  }} transition={{
    duration: 0.18,
    ease: [0.23, 1, 0.32, 1]
  }} className="group flex flex-col h-full bg-white rounded-3xl border border-slate-100 overflow-hidden shadow-[0_4px_20px_var(--mp-card-shadow)] hover:shadow-[0_14px_38px_var(--mp-card-shadow)] transition-shadow duration-200 ease-out" data-id="element-4478" data-mp="3ls7xnhgj9vha">
      <div className="relative aspect-[4/3] bg-slate-50 overflow-hidden" data-id="element-4479" data-mp="163g2xmkehdsq">
        <img src={vehicle.image} alt={vehicle.name} className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]" data-id="element-4480" data-mp="1aybukllq5z5b" />
        {vehicle.badge && <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-[var(--ma)] text-[10px] font-bold uppercase tracking-wider shadow-sm" style={{
        color: 'var(--ma-t)'
      }} data-id="element-4481" data-mp="3e69pky9lzj9s">
            {vehicle.badge}
          </span>}
      </div>

      <div className="flex flex-col flex-1 p-5" data-id="element-4482" data-mp="2zhlxx32vvtp4">
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[var(--mp)]" data-id="element-4483" data-mp="2zfstlufqtlka">
          {vehicle.category}
        </p>
        <h3 className="font-display font-bold text-[15px] text-[var(--mp-deep)] leading-snug mt-1.5" data-id="element-4484" data-mp="2qgnuon09rq7l">
          {vehicle.name}
        </h3>
        <p className="text-[13px] text-slate-400 mt-1" data-id="element-4485" data-mp="2lgjcmsjpqnf9">{vehicle.details}</p>

        <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-4486" data-mp="2ghzoclhnczjq">
          <p className="font-display font-bold text-lg text-[var(--mp-deep)]" data-id="element-4487" data-mp="2gkkqlbluxhi0">
            {vehicle.monthly}
          </p>
          <p className="text-xs text-slate-400 mt-0.5" data-id="element-4488" data-mp="2btp4evd5f1ug">or {vehicle.daily}</p>
        </div>

        {/* Every action leads back into the conversation */}
        <div className="mt-auto pt-5 flex flex-col gap-2" data-id="element-4489" data-mp="1xvs71wqvereq">
          <button onClick={() => onAsk(vehicle)} className="w-full inline-flex items-center justify-center gap-2 py-2.5 bg-[var(--mp)] text-[13px] font-semibold hover:bg-[var(--mp-d)] active:scale-[0.98] transition-[background-color,transform] duration-150 ease-out" style={{
          color: 'var(--mp-t)',
          borderRadius: 'var(--m-r)'
        }} data-id="element-4490" data-mp="21v9dase4fsky">
            <SparklesIcon className="w-4 h-4" style={{
            color: 'var(--ma)'
          }} data-id="element-4491" data-mp="2ktlo0ikolain" />
            Ask about this car
          </button>
          <div className="grid grid-cols-2 gap-2" data-id="element-4492" data-mp="3dbzm8j9xiyi9">
            <button onClick={() => onCheckAvailability(vehicle)} className="inline-flex items-center justify-center gap-1.5 py-2.5 bg-white border border-slate-200 text-[12px] font-semibold text-slate-600 hover:border-[var(--mp-50)] hover:text-[var(--mp-d)] transition-colors duration-150 ease-out" style={{
            borderRadius: 'var(--m-r)'
          }} data-id="element-4493" data-mp="3dcsop81uv1ul">
              <CalendarCheckIcon className="w-3.5 h-3.5" data-id="element-4494" data-mp="iwl83yp5782d" />
              Availability
            </button>
            <button onClick={() => onCompare(vehicle)} className="inline-flex items-center justify-center gap-1.5 py-2.5 bg-white border border-slate-200 text-[12px] font-semibold text-slate-600 hover:border-[var(--mp-50)] hover:text-[var(--mp-d)] transition-colors duration-150 ease-out" style={{
            borderRadius: 'var(--m-r)'
          }} data-id="element-4495" data-mp="dytff2gobhx4">
              <GitCompareIcon className="w-3.5 h-3.5" data-id="element-4496" data-mp="1zabfbebk6cg8" />
              Compare
            </button>
          </div>
        </div>
      </div>
    </motion.article>;
}